// extracted by mini-css-extract-plugin
export default {"container":"pWPhqT","text":"XwKV_y"};